import { StyleSheet } from "react-native"
import { appColors, appFonts, fontSize } from "../../appTheme"

export const taxListStyle = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: appColors?.lightBackgroundColor
    },
    plusIconView: {
        alignSelf: "flex-end",
        backgroundColor: appColors.primary,
        borderRadius: 50,
        alignItems: "center",
        justifyContent: "center",
        height: 55,
        width: 55,
        position: "absolute",
        bottom: 25,
        right: 25
    },
})